#import '../queries/HaftarahDetails.graphql'
mutation CreateOrUpdateHaftarah(
  $year: Int
  $parashah: ID!
  $section: String!
  $variant: String!
  $id: Int
  $comment: String
  $username: String
) {
  createHaftarah(
    year: $year
    parashah: $parashah
    section: $section
    variant: $variant
    id: $id
    comment: $comment
    username: $username
  ) {
    ok
    errors
    haftarah {
      ...haftarahDetails
    }
  }
}
